import { EKwikUIInputSize } from "./input-slider.definitions";

export const DEFAULT_VALUES = {
  disabled: false,
  focus: false,
  formControlName: "form_control_input",
  hintContent: "",
  icon: "",
  id: "input",
  invalid: false,
  isShowLabelOutside: false,
  label: "Input",
  max: 100,
  min: 0,
  placeholder: "Please enter input",
  postfix: "",
  prefix: "",
  quantum: 1,
  size: EKwikUIInputSize.L,
  steps: 0,
  type: "input-slider"
};

export const VALIDATE_KEY_VALUES = {
  disabled: true,
  focus: true,
  formControlName: true,
  hintContent: true,
  icon: true,
  id: true,
  invalid: true,
  isShowLabelOutside: true,
  label: true,
  max: true,
  min: true,
  placeholder: true,
  postfix: true,
  prefix: true,
  quantum: true,
  size: true,
  steps: true,
  type: true
};
